/**
 * Takes multiple fields, and makes them readonly.
 * @param {String} params.field - This field's data you want to make readonly
 */
export const newOrder = function (params: any, schema: any, uiSchema: any, formData: any) {
  uiSchema["ui:order"] = params.order || ["*"]
};


// Action validation
if (process.env.NODE_ENV !== 'production') {

  const PropTypes = require('prop-types');

  newOrder.propTypes = {
    order: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  newOrder.validate = function ({ order }: any, schema: any, uiSchema: any) {
    if (!Array.isArray(order)) {
      console.error(`Order is missing from parameters`)
    }
  };

}